import React, { useEffect, useState } from "react";
import ProductDetailPDFCustomOffer from "./templates/ProductDetailPDFCustomOffer";
import { PDFViewer } from "@react-pdf/renderer";
import { useDispatch, useSelector } from "react-redux";
import { getProductDetail } from "../../redux/actions/productActions";
import { getProductSpecification } from "../../redux/actions/productActions";
import SecureLS from 'secure-ls';

const ProductPdf = () => {

    const dispatch = useDispatch();
    const productsDetail = useSelector((state) => state.productDetail.items);
    const productsDetailSpec = useSelector((state) => state.getProductSpecification);
    let ls = new SecureLS({ encodingType: 'aes' });

    const anActiveVat = JSON.parse(localStorage.getItem('activeVat'))
    const offer = JSON.parse(ls.get('customOffer'));

    useEffect(() => {
        dispatch(getProductDetail(offer.productId));
        dispatch(getProductSpecification(offer.productId));
    }, []);

    if (productsDetailSpec) {
        if (!productsDetailSpec.list) {
            return null;
        }
    } else {
        return null
    }

    return (
        <PDFViewer style={{ width: "100vw", height: "100vh" }}>
            {productsDetail.length > 0 && <ProductDetailPDFCustomOffer item={productsDetail[0]} spec={productsDetailSpec.list} custom={offer} currency={offer.currency} activeVat={anActiveVat} badges2={productsDetailSpec.filterIcons} />}
        </PDFViewer>
    );
};

export default ProductPdf;
